<template>
  <div id="app">
    <b-container fluid class="wrapper">
      <router-view/>
    </b-container>
    <div class="logo position-absolute" v-if="showLogo">
      <img src="@/assets/img/RA_Logo_Bug-LeftText_white.svg" />
    </div>
    <b-button class="position-absolute hamburger" v-b-toggle.sidebar-right variant="link">
      <img src="@/assets/img/burger-menu.svg" />
    </b-button>
    <b-sidebar id="sidebar-right" title="Explore" right>
      <template #header>
        <h4>EXPLORE</h4>
        <b-button class="close position-absolute" v-b-toggle.sidebar-right>
          <img src="@/assets/img/menu/menu-x.svg" />
        </b-button>
      </template>
      <h3><router-link to="/">Home</router-link></h3>
      <h3><router-link to="/explore">Model Predictive Control</router-link></h3>
      <p class="heading"><router-link to="/benefits">BENEFITS BY AREA</router-link></p>
      <p><router-link to="/benefits/blender">Blending</router-link></p>
      <p><router-link to="/benefits/kiln">Cement Kiln</router-link></p>
      <p><router-link to="/benefits/grinding">Grinding</router-link></p>
      <p class="heading"><router-link to="/mpc">MPC TECHNOLOGY</router-link></p>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'showLogo'
    ])
  },
  name: 'App'
}
</script>

<style lang='scss' src='@/assets/css/section.scss'></style>
<style src='../public/css/barlow.css'></style>
<style src='../public/css/style.css'></style>
<style lang="scss">
@import 'assets/css/custom-vars.scss';
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

html, body, #app, .wrapper {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  background-color:#0b0203;
}

#app {
  color: var(--white);
  font-family: 'Barlow', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  h1, h2, h3, h4, h5 {
    font-weight: 800;
  }

  h1 {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  h1, .h1 {
    font-size: 2.5rem;
  }

  .annotation h3 {
    margin-top:20px!important;
  }

  .return {
    h4 {
      font-weight:normal;
    }
  }

  p {
    margin-bottom: 1.5rem;
  }

  ul {
    padding-left: 25px;
  }

  .b-sidebar-body {
    padding: 2.5rem 1rem 1rem 1rem;

    a {
      color: var(--black);
    }

    h3, p {
      background: url('assets/img/menu/menu-gray-line.svg');
      background-position: bottom;
      background-repeat: no-repeat;
      padding-bottom: 1.1rem;
    }

    p {
      padding-left: 3.0rem;
    }

    .heading {
      padding-left: 1.5rem;
    }
  }

  .b-sidebar-header {
    background: url('assets/img/menu/menu-yellow-line.svg');
    background-position: bottom;
    background-repeat: no-repeat;
       padding: 1.25rem 1rem .25rem 1rem;

    .close {
      right: .05rem;
    }
    h4{font-weight:normal;}
  }

  .Blender .benefits-gradient {
    background: url('assets/img/benefits/black-overlay-left.svg') no-repeat;
  }

  .benefits-gradient {
    background: url('assets/img/benefits/black-overlay-left.svg') no-repeat;
    background-size: cover;
    position: absolute;
    width: 103%;
    height: 103%;
    top: -3%;
    left: -3%;
  }

  .black-gradient {
    background: rgb(0,0,0);
    background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.47522759103641454) 100%);
    position: fixed;
    width: 103%;
    height: 103%;
    top: -3%;
    left: -3%;
  }

  .blue-gradient {
    background: url('assets/img/dark-blue-gradient.svg') no-repeat;
    background-size: cover;
    position: absolute;
    width: 103%;
    height: 103%;
    top: -3%;
    left: -3%;
  }

  .bottom {
    bottom: 5%;
  }

  .bottom, .default, #annotationContainer {
    left: 3%;
    width: 96%;
  }

  .bread {
    margin-bottom: 5px;

    & span {
      margin-right: 20px;
      &:not(:first-of-type) {
        margin-left: 20px;
      }

      &:hover {
        cursor: pointer;
      }
    }

    & strong {
      margin-left: 20px;
    }
  }

  .btn {
    color: var(--white);
    margin-bottom: 15px;
    margin-right: 20px;
    margin-top: 5px;
    padding: 6px 35px;

    &:hover {
      background: rgba(248, 194, 20, 0.8)!important;
    }

    &:not(.active):not(.close):not(.hamburger) {
      background: rgba(0, 0, 0, 0.4);
    }
  }

  .btn-outline-primary {
    color: var(--white);
    font-weight: 700;
  }

  .divider {
    max-width: 50px;
  }

  .hamburger {
    right: 20px;
    top: 20px;
  }

  .logo {
    right: 20px;
    bottom: 0px;
  }

  .orange-gradient {
    background: url('assets/img/orange-bottom-gradient.svg') no-repeat;
    background-size: cover;
    position: absolute;
    width: 103%;
    height: 103%;
    top: -3%;
    left: -3%;
  }

  .wrapper {
    padding: 0;
  }
}
</style>
